// extracted by mini-css-extract-plugin
export default {"root":"b6Vcok","isDisabled":"IRc51N","voteCount":"bzxEI1","vote":"C0ttGh","isActive":"a8XtA5"};